<template>
  <div id="app">
    <div class="header">
      <h1>지출 관리 앱</h1>
      <div class="header-buttons">
        <button @click="showCategoryModal" class="header-btn">지출 항목 관리</button>
        <button @click="toggleView" class="header-btn">
          {{ isSpeedView ? '지출 내역' : '지출 속도' }}
        </button>
      </div>
    </div>

    <!-- 뷰 전환 -->
    <div class="container">
      <expense-list v-if="!isSpeedView"></expense-list>
      <expense-speed v-else></expense-speed>
    </div>

    <!-- 모달 팝업 -->
    <div v-if="isModalVisible" class="modal-overlay" @click="hideModal">
      <div class="modal-content" @click.stop>
        <button class="close-btn" @click="hideModal">×</button>
        <div class="modal-header">
          <h2>지출 항목 관리</h2>
        </div>
        <expense-categories></expense-categories>
      </div>
    </div>
  </div>
</template>

<script>
import ExpenseCategories from './components/ExpenseCategories.vue'
import ExpenseList from './components/ExpenseList.vue'
import ExpenseSpeed from './components/ExpenseSpeed.vue'

export default {
  name: 'App',
  components: {
    ExpenseCategories,
    ExpenseList,
    ExpenseSpeed
  },
  data() {
    return {
      isModalVisible: false,
      isSpeedView: false
    }
  },
  methods: {
    showCategoryModal() {
      this.isModalVisible = true
      document.body.style.overflow = 'hidden'
    },
    hideModal() {
      this.isModalVisible = false
      document.body.style.overflow = 'auto'
    },
    toggleView() {
      this.isSpeedView = !this.isSpeedView
    }
  }
}
</script>

<style>
#app {
  font-family: Arial, sans-serif;
  max-width: 800px;
  margin: 0 auto;
  padding: 10px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding: 0 5px;
}

.header h1 {
  margin: 0;
  font-size: 20px;
}

.header-buttons {
  display: flex;
  gap: 10px;
}

.header-btn {
  padding: 8px 16px;
  background-color: #2196F3;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.container {
  animation: fade 0.3s ease;
}

@keyframes fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* 모달 스타일은 유지 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 95%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 40px;
  height: 40px;
  font-size: 32px;
  background: none;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666;
  transition: all 0.2s ease;
  z-index: 1;
}

.close-btn:hover {
  background-color: #f0f0f0;
  color: #333;
}

.modal-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.modal-header h2 {
  margin: 0;
  font-size: 22px;
  color: #333;
}

/* 모바일 최적화 */
@media (max-width: 600px) {
  .header {
    flex-direction: column;
    gap: 10px;
  }

  .header h1 {
    font-size: 22px;
  }

  .header-buttons {
    width: 100%;
  }

  .header-btn {
    flex: 1;
    font-size: 16px;
    padding: 12px;
    text-align: center;
  }

  .modal-content {
    padding: 20px;
  }

  .close-btn {
    top: 15px;
    right: 15px;
    width: 48px;
    height: 48px;
    font-size: 36px;
  }

  .modal-header h2 {
    font-size: 24px;
  }
}
</style> 